// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class ContentArea extends Vue {
  public created() {}

  public mounted() {}

  public destroyed() {}
}
